(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("antdCssinjs"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["HighlightCode"] = factory(require("react"), require("react-dom"), require("antdCssinjs"));
	else
		root["HighlightCode"] = factory(root["React"], root["ReactDOM"], root["antdCssinjs"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__868__, __WEBPACK_EXTERNAL_MODULE__1238__, __WEBPACK_EXTERNAL_MODULE__283__) {
return 